.tabList {
  display: flex;
  gap: var(--nexus-space-xs);
  /* The rule is drawn inside the list rather than as a border, and the active
     underline sits on it from within each tab — so a list too wide for its
     container can scroll sideways without clipping either. */
  box-shadow: inset 0 -1px 0 var(--nexus-border-subtle);
  padding-bottom: 0;
  overflow-x: auto;
  scrollbar-width: none;
}

.tabList::-webkit-scrollbar {
  display: none;
}

.tab {
  position: relative;
  display: flex;
  align-items: center;
  gap: var(--nexus-space-xs);
  padding: var(--nexus-space-sm) var(--nexus-space-lg);
  padding-bottom: calc(var(--nexus-space-sm) + 2px);
  border: none;
  background: transparent;
  color: var(--nexus-text-secondary);
  font-size: var(--nexus-text-sm);
  font-weight: 500;
  cursor: pointer;
  transition: color var(--nexus-transition-fast);
  white-space: nowrap;
  flex-shrink: 0;
}

/* gradient underline — slides in from left on hover */
.tab::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  border-radius: 1px;
  background: var(
    --tab-active-gradient,
    linear-gradient(
      90deg,
      var(--org-accent-grad-start, var(--nexus-purple)),
      var(--org-accent-grad-end, var(--nexus-pink)),
      transparent
    )
  );
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 250ms cubic-bezier(0.4, 0, 0.2, 1);
}

.tab:hover {
  color: var(--nexus-text);
}

.tab:hover::after {
  transform: scaleX(0.5);
}

.tabActive {
  color: var(--nexus-text);
}

.tabActive::after {
  transform: scaleX(1);
}

.tabBadge {
  font-size: 11px;
  padding: 1px 6px;
  min-width: 20px;
  text-align: center;
  background: rgba(255, 255, 255, 0.08);
  border-radius: var(--nexus-radius-full);
}

@media (max-width: 768px) {
  .tabList {
    gap: 0;
  }

  /* Share the width while the tabs fit; past that they keep their size and
     the list scrolls, rather than wrapping each label onto two lines. */
  .tab {
    flex: 1 0 auto;
    justify-content: center;
    padding: var(--nexus-space-sm) var(--nexus-space-md);
  }
}
